import { FC } from 'react';

import { LayoutWithNavigationBreadcrumbs } from 'components';
import { FormSubmit } from 'libs/form';
import { useTranslation } from 'libs/i18n';
import { RoutesId } from 'libs/navigation';
import { Stack } from 'libs/ui';

import { FormFooter, Header, ProductionCalendar } from '../components';
import {
  Form,
  ProductionCalendarFormType,
  productionCalendarSchema,
} from '../forms/productionCalendarForm';

export type ProductionCalendarViewProps = {
  weekendsDate?: Date[];
  submitLoading?: boolean;
  onSubmit: FormSubmit<ProductionCalendarFormType>;
};

export const ProductionCalendarView: FC<ProductionCalendarViewProps> = ({
  weekendsDate,
  submitLoading,
  onSubmit,
}) => {
  const { t } = useTranslation();
  return (
    <LayoutWithNavigationBreadcrumbs
      titles={{
        [RoutesId.productionCalendar]: t('directory.productionCalendar.title'),
      }}
    >
      <Stack spacing={24}>
        <Form
          initialReadOnly
          initialValues={{ weekendsDate }}
          validationSchema={productionCalendarSchema}
          onSubmit={onSubmit}
        >
          <Header />
          <ProductionCalendar />
          <FormFooter submitLoading={submitLoading} />
        </Form>
      </Stack>
    </LayoutWithNavigationBreadcrumbs>
  );
};
